import "../../../FhInputContainer.css";
import { useSlots, computed, inject, openBlock, createElementBlock, normalizeClass, normalizeStyle, createElementVNode, unref, createBlock, createCommentVNode, withCtx, renderSlot, withModifiers, createTextVNode } from "vue";
import useGetFieldValue from "../composables/useGetFieldValue.mjs";
import FhIcon from "../../FhIcon/FhIcon.mjs";
import FhIconButton from "../../Buttons/FhIconButton/FhIconButton.mjs";
import FhText from "../../FhText/FhText.mjs";
import clear from "../../../icons/clear.mjs";
import { SIZES_ENUMS } from "./constants.mjs";
import { InputFieldContextKey } from "../Symbols.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-input-wrap" };
const _hoisted_2 = {
  key: 0,
  class: "fh-input-slot--prefix"
};
const _hoisted_3 = { class: "fh-input-slot--default" };
const _hoisted_4 = {
  key: 0,
  class: "fh-input--decorators"
};
const _hoisted_5 = {
  key: 1,
  class: "fh-input-slot--suffix"
};
const _hoisted_6 = {
  key: 0,
  class: "fh-input-slot--footer"
};
const _sfc_main = {
  __name: "FhInputContainer",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: void 0
    },
    valid: {
      type: Boolean,
      default: void 0
    },
    prefixIcon: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    decoratorIcon: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: SIZES_ENUMS.SM,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    prefixSuffixColor: {
      type: String,
      default: "subtle"
    }
  },
  emits: ["clearable:click"],
  setup(__props, { emit: __emit }) {
    const slots = useSlots();
    const emit = __emit;
    const props = __props;
    const computedInputStyles = computed(() => {
      return {
        maxWidth: props.maxWidth
      };
    });
    const inputFieldContext = inject(InputFieldContextKey, void 0);
    const currentValue = useGetFieldValue();
    const computedDisabled = computed(
      () => (inputFieldContext == null ? void 0 : inputFieldContext.disabled) || props.disabled
    );
    const computedFocused = computed(
      () => (inputFieldContext == null ? void 0 : inputFieldContext.focused) || props.focused
    );
    const computedValid = computed(() => (inputFieldContext == null ? void 0 : inputFieldContext.valid) || props.valid);
    const computedClearable = computed(() => {
      return props.clearable && !props.disabled && currentValue.value;
    });
    const computedInputClasses = computed(() => {
      return [
        "fh-input-container",
        props.size && `fh-input-container--${props.size}`,
        computedDisabled.value && "fh-input-container--disabled",
        !computedValid.value && "fh-input-container--invalid",
        computedFocused.value && !computedDisabled.value && "fh-input-container--focused",
        (props.prefixIcon || slots.prefix) && "fh-input-container--prefix",
        (props.suffixIcon || slots.suffix || slots.action) && "fh-input-container--suffix",
        slots.footer && "fh-input-container--footer",
        props.decoratorIcon && "fh-input-container--decorator-icon",
        computedClearable.value && "fh-input-container--clear"
      ];
    });
    const computedIconColor = computed(() => {
      return props.disabled ? "disabled" : "subtle";
    });
    const computedTextColor = computed(() => {
      return props.disabled ? "disabled" : props.prefixSuffixColor;
    });
    const computedDecoratorIconColor = computed(() => {
      return props.disabled ? "disabled" : "default";
    });
    const emitClearAction = () => {
      emit("clearable:click");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(computedInputClasses.value),
        style: normalizeStyle(computedInputStyles.value)
      }, [
        createElementVNode("div", _hoisted_1, [
          unref(slots).prefix || props.prefixIcon ? (openBlock(), createElementBlock("div", _hoisted_2, [
            props.prefixIcon ? (openBlock(), createBlock(FhIcon, {
              key: 0,
              icon: props.prefixIcon,
              color: computedIconColor.value,
              size: "sm"
            }, null, 8, ["icon", "color"])) : createCommentVNode("", true),
            unref(slots).prefix ? (openBlock(), createBlock(FhText, {
              key: 1,
              variant: "body-md",
              tag: "span",
              color: computedTextColor.value,
              class: "fh-input-slot-wrap"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["color"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true),
            props.decoratorIcon || computedClearable.value ? (openBlock(), createElementBlock("div", _hoisted_4, [
              computedClearable.value ? (openBlock(), createBlock(FhIconButton, {
                key: 0,
                class: "fh-button--clear",
                icon: unref(clear),
                size: "xs",
                variant: "plain",
                onClick: withModifiers(emitClearAction, ["prevent"])
              }, {
                default: withCtx(() => [
                  createTextVNode(" Clear ")
                ]),
                _: 1
              }, 8, ["icon"])) : createCommentVNode("", true),
              props.decoratorIcon ? (openBlock(), createBlock(FhIcon, {
                key: 1,
                class: "fh-icon--decorator",
                icon: props.decoratorIcon,
                size: "sm",
                color: computedDecoratorIconColor.value
              }, null, 8, ["icon", "color"])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ]),
          unref(slots).suffix || props.suffixIcon || unref(slots).action ? (openBlock(), createElementBlock("div", _hoisted_5, [
            unref(slots).suffix ? (openBlock(), createBlock(FhText, {
              key: 0,
              variant: "body-md",
              tag: "span",
              color: computedTextColor.value,
              class: "fh-input-slot-wrap"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["color"])) : createCommentVNode("", true),
            props.suffixIcon ? (openBlock(), createBlock(FhIcon, {
              key: 1,
              icon: props.suffixIcon,
              color: computedIconColor.value,
              size: "sm"
            }, null, 8, ["icon", "color"])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "action", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        unref(slots).footer ? (openBlock(), createElementBlock("div", _hoisted_6, [
          renderSlot(_ctx.$slots, "footer", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 6);
    };
  }
};
const FhInputContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b4bcd06f"]]);
export {
  FhInputContainer as default
};
//# sourceMappingURL=FhInputContainer.mjs.map
